// extracted by mini-css-extract-plugin
export default {"container":"onL_4w","noResults":"Uujbv5","link":"cxNpyT","header":"hq5J6f","date":"ev_BXU","title":"G0d1Ly","container--mobile":"lJMbu0"};